import { ADDED_NEW_NOTIFICATION_SUCCESS, SET_CLEAR_NOTIFICATION } from './constants'

export const addedNewNotifacationSuccess = (message) => ({
  type: ADDED_NEW_NOTIFICATION_SUCCESS,
  payload: message,
})

export const setClearNotification = () => ({
  type: SET_CLEAR_NOTIFICATION
})